/**
 * @link http://scratch99.com/web-development/javascript/convert-bytes-to-mb-kb/
 * @param bytes
 * @returns {*}
 */
export function bytesToSize(bytes) {
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	if (bytes === 0) {
		return 'n/a';
	}
	let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	if (i === 0) {
		return bytes + ' ' + sizes[i];
	}
	return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}




// WEBPACK FOOTER //
// ./resources/assets/js/helpers/files.js